/**
 * UC-02: SaveGame
 * Persists the current game snapshot through IGameRepository.
 */
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { GameSaveSnapshot, IGameRepository } from '../../domain/ports/IGameRepository';
import { SAVE_VERSION } from '../../infrastructure/config/persistence';

export type SaveGameInput = Omit<GameSaveSnapshot, 'version' | 'timestamp' | 'savedAt'>;

export interface SaveGameDependencies {
  repository: IGameRepository;
  logger?: IAppLogger;
}

export class SaveGameUseCase {
  constructor(private readonly deps: SaveGameDependencies) {}

  async execute(input: SaveGameInput): Promise<void> {
    const snapshot: GameSaveSnapshot = {
      ...input,
      version: SAVE_VERSION,
      timestamp: Date.now(),
      savedAt: new Date().toISOString(),
    };

    await this.deps.repository.save(snapshot);

    this.deps.logger?.log('debug', 'game.saved', {
      day: input.stats.day,
      gameStatus: input.gameStatus,
    });
  }
}